import { Component, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'delete-document-dialog',
    templateUrl: 'delete-document-dialog.html',
})
export class DeleteDocumentDialog {
    readonly dialogRef = inject(MatDialogRef<DeleteDocumentDialog>);
    readonly data = inject<DialogData>(MAT_DIALOG_DATA);

    deleteFile(confirmDelete: boolean): void {
        this.dialogRef.close(confirmDelete);
    }
}

export interface DialogData {
    type: string;
    fileName: string;
}